import { Component, Input } from '@angular/core';
import { IeIconsComponent } from '@ieShared/components/ie-icons/ie-icons.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-no-internet',
  imports: [IeIconsComponent, TranslateModule, NgClass],
  templateUrl: './no-internet.component.html',
  styleUrl: './no-internet.component.scss',
})
export class NoInternetComponent {
  @Input() online: boolean = true;
}
